<template lang="pug">
  b-form-select(
    :value="value"
    :size="size"
    :class="{ 'is-invalid': dirty == true && error == true, 'is-valid': dirty == true && error == false }"
    @input="handleInput"
    )
    option(value="" disabled selected) {{ $t("message.select_option") }}
    option(v-for="option in options" :value="option.value" v-if="isEnableOpt(option.value)") {{ option.text }}
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: ""
    },
    size: {
      type: String,
      default: "md"
    },
    dirty: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    },
    hideOpt: {
      type: Array,
      default: null
    }
  },
  data: () => ({
    options: [
      {
        value: "INCOMING",
        text: "INCOMING"
      },
      {
        value: "OUTGOING",
        text: "OUTGOING"
      },
      {
        value: "BOTH",
        text: "BOTH"
      }
    ]
  }),
  methods: {
    handleInput(e) {
      this.$emit("input", e);
    },
    isEnableOpt(value) {
      if (this.hideOpt && this.hideOpt.length > 0) {
        if (this.hideOpt.includes(value))
          return false;
      }

      return true;
    }
  }
};
</script>
